import { z } from 'zod/v4';

export const dataShareSettingsSchema = z.object({
  shareDataAnonymously: z.boolean(),
  shareTripData: z.boolean(),
});

export type DataShareSettings = z.infer<typeof dataShareSettingsSchema>;
